export default "__VITE_ASSET__91e120b7__"